<template>
  <div class="bg-white md:pt-32 lg:pt-32 pt-24 relative">
    <div class="absolute top-48 right-0 md:block lg:bloch hidden">
      <img
        src="../../../assets/images/bg-des/career-dots.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-1/3 left-0 md:block lg:bloch hidden">
      <img
        src="../../../assets/images/bg-des/CD-dots2.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-48 left-1/4 md:block lg:bloch hidden">
      <img
        src="../../../assets/images/bg-des/career-poly.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-1/3 right-32 md:block lg:bloch hidden">
      <img src="../../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="absolute top-1/2 left-32 md:block lg:bloch hidden">
      <img src="../../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="absolute top-48 right-1/4 md:block lg:bloch hidden">
      <img src="../../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="md:w-4/5 lg:w-4/5 w-full mx-auto lg:px-0 md:px-0 px-5">
      <div class="flex justify-between items-center">
        <div class="flex items-center">
          <p class="fsize48-24 font-semibold text-black">
            {{ selectedCareer.jobRole }}
          </p>
          <!-- <img
            src="../../../assets/images/logo/career-share.svg"
            alt="ShareIcon"
            class="md:h-8 lg:h-8 h-4 ml-4"
          /> -->
        </div>
        <!-- <div class="md:block lg:bloch hidden">
          <base-button type="primary" class="px-12 py-2 fs16700 border-2"
            >Apply</base-button
          >
        </div> -->
      </div>
      <p class="joinus-subtitle clr777 fsize24-14px">
        Location: {{ selectedCareer.location }}
      </p>
      <div class="md:pt-20 lg:pt-20 pt-8">
        <div>
          <p class="underline care-det-title text-black fsize24-14px">
            Responsibilities Include
          </p>
          <p
            class="pt-6 subtitle tracking-wide fsize24-14px"
            v-html="selectedCareer.responsibility"
          ></p>
          <!-- <ul
            class="
              pt-4
              md:pl-6
              lg:pl-6
              pl-4
              subtitle
              tracking-wide
              fsize24-14px
            "
          >
            <li>
              Administer Caregiver Saathi's burnout tool, analyze and prepare
              detailed reports of the same
            </li>
            <li>
              Assist in content development related to psychology for Caregiver
              Saathi education
            </li>
            <li>
              Conduct research on various psychological issues related to
              caregiving for handbooks prepared by the organization
            </li>
            <li>Facilitate in developing and conducting workshops</li>
            <li>
              Assist in social media activities, share and implement ideas for
              social media initiatives
            </li>
          </ul> -->
        </div>

        <div class="md:pt-10 lg:pt-10 pt-8">
          <p class="underline care-det-title text-black fsize24-14px">
            Skills Required
          </p>
          <p
            class="pt-6 subtitle tracking-wide fsize24-14px"
            v-html="selectedCareer.skills"
          ></p>
        </div>
      </div>

      <!-- <div class="md:pt-20 lg:pt-20 pt-12">
        <div class="w-full bgE4D8F5 relative z-index1">
          <div class="absolute top-0 left-0 z-index--1">
            <img src="../../../assets/images/bg-des/form-t1.svg" alt="Bg des" />
          </div>
          <ApplyJob :subject="selectedCareer.jobRole" />
        </div>
      </div> -->
    </div>
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<style scoped>
li {
  padding-top: 10px;
  list-style: disc;
}
</style>
<script>
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
import ApplyJob from "../components/ApplyJob.vue";
import { mapState } from "vuex";

export default {
  components: {
    DownloadApp,
    Footer,
    ApplyJob,
  },
  data() {
    return {
      // subject: "",
    };
  },
  async mounted() {
    await this.getSingle();
    // this.subject = this.selectedCareer.jobRole;
  },
  computed: {
    ...mapState("cms", ["selectedCareer"]),
  },
  beforeCreate() {
    this.$store.commit("cms/SET_SELECTED_CAREER", {});
  },
  methods: {
    async getSingle() {
      let loader = this.$loading();
      try {
        await this.$store.dispatch(
          "cms/getSingleCareer",
          this.$route.params.id
        );
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
};
</script>
